import { showAllComparisonMode } from '../utils/comparison-mode-options'
import { comparisonModes, filters } from '../constants'
import {
  periodLockStatusLabelKeys,
  periodLockStatusOrder,
} from '@app/insights/types'
import { SfTime } from '@app/adapters/time'

export const periodLockedDefinition = {
  type: filters.PERIOD_LOCKED,
  nameKey: 'period_locked',
  ledgerRequired: true,

  comparisonModes() {
    return [
      ...showAllComparisonMode(),
      {
        label: I18n.t('companies_overview.filters.period_locked.not_locked'),
        value: comparisonModes.FALSE,
      },
      {
        label: I18n.t('companies_overview.filters.period_locked.locked_option'),
        value: comparisonModes.TRUE,
      },
      {
        label: I18n.t(
          'companies_overview.filters.period_locked.locked_permanently_option'
        ),
        value: 'permanently',
      },
    ]
  },

  activeSubtitle(settings) {
    const title = I18n.t('companies_overview.filters.period_locked.title')

    if (settings.comparisonValue === comparisonModes.SHOW_ALL) {
      return `${title}: ${I18n.t(
        'companies_overview.filters.comparison_modes.show_all'
      )}`
    } else if (settings.comparisonValue === comparisonModes.TRUE) {
      return I18n.t('companies_overview.filters.period_locked.locked_option')
    } else if (settings.comparisonValue === comparisonModes.FALSE) {
      return I18n.t('companies_overview.filters.period_locked.not_locked')
    } else if (settings.comparisonValue === 'permanently') {
      return I18n.t(
        'companies_overview.filters.period_locked.locked_permanently_option'
      )
    }
  },

  serializeSettings(settings) {
    return {
      comparison_value: settings.comparisonValue,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonValue: params.comparison_value,
    }
  },

  formatForExport(value) {
    if (!value || typeof value === 'string') {
      return value || ''
    }

    const labelKey = periodLockStatusLabelKeys[value.status]
    const parts = [labelKey ? I18n.t(labelKey) : '']

    if (value.locked_at) {
      parts.push(SfTime(value.locked_at).format('DD/MM/YYYY'))
    }

    if (value.locked_by_name) {
      parts.push(value.locked_by_name)
    }

    return parts.filter(Boolean).join(', ')
  },

  sortValue(value) {
    if (value && typeof value === 'object') {
      return periodLockStatusOrder[value.status] ?? (value.status || '')
    }
    return value || ''
  },
}
